import axiosInstance from "../common/axiosInstance";
import {
  useMutation,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query";

export const PATHS = Object.freeze({
  ADD_ANALYZER: "/recall-bot/add-analyzer",
  ADD_ANALYZER_ADHOC: "/recall-bot/adhoc-bot",
  ADD_ANALYZER_UPCOMING: "/recall-bot/analyzer-action-handler",
  REMOVE_ANALYZER: "/recall-bot/remove-analyzer",
});

export interface AddAnalyzerParams {
  interactionID: string;
  employeeEmail: string;
}

export interface AddAnalyzerAdhocParams {
  employeeEmail: string;
  interactionId: string;
  meetingUrl?: string;
}
export interface AddAnalyzerResponse {
  // define the expected response shape here, e.g.
  success: boolean;
  message: string;
}

export interface AnalyzerActionParams {
  interactionId: string;
  analyzerAction: "schedule" | "deschedule";
  meetingUrl?: string;
}

export interface AnalyzerActionResponse {
  success: boolean;
  message: string;
}
export interface RemoveAnalyzerResponse {
  success: boolean;
  message: string;
}

const addAnalyzer = async (params: AddAnalyzerParams): Promise<AddAnalyzerResponse> => {
  const { interactionID, employeeEmail } = params;

  const response = await axiosInstance.post(PATHS.ADD_ANALYZER, null, {
    params: {
      interactionID,
      employeeEmail,
    },
    responseType: 'text',
  });
  
  console.log(response.data);
  return {
    success: true,
    message: response.data as string,
  };
};

const addAnalyzerAdhoc = async (params: AddAnalyzerAdhocParams): Promise<AddAnalyzerResponse> => {
  const { employeeEmail, interactionId, meetingUrl } = params;

  const response = await axiosInstance.post(PATHS.ADD_ANALYZER_ADHOC, null, {
    params: {
      employeeEmail,
      interactionId,
      meetingUrl,
    },
    responseType: 'text',
  });
  
  console.log(response.data);
  return {
    success: true,
    message: response.data as string,
  };
}

const useAddAnalyzer = (
  options?: UseMutationOptions<AddAnalyzerResponse, unknown, AddAnalyzerParams>
): UseMutationResult<AddAnalyzerResponse, unknown, AddAnalyzerParams> => {
  return useMutation({
    mutationKey: ['add_analyzer'],
    mutationFn: addAnalyzer,
    ...options,
  });
};

const useAddAnalyzerAdhoc = (
  options?: UseMutationOptions<AddAnalyzerResponse, unknown, AddAnalyzerAdhocParams>
): UseMutationResult<AddAnalyzerResponse, unknown, AddAnalyzerAdhocParams> => {
  return useMutation({
    mutationKey: ['add_analyzer_adhoc'],
    mutationFn: addAnalyzerAdhoc,
    ...options,
  });
}

const analyzerActionHandler = async (
  params: AnalyzerActionParams
): Promise<AnalyzerActionResponse> => {
  const { interactionId, analyzerAction, meetingUrl } = params;

  const response = await axiosInstance.post(
    PATHS.ADD_ANALYZER_UPCOMING,
    null,
    {
      params: {
        interactionId,
        analyzerAction,
        ...(meetingUrl ? { meetingUrl } : {}),
      },
    }
  );

  return {
    success: true,
    message: response.data as string,
  };
};
const useAnalyzerAction = (
  options?: UseMutationOptions<
    AnalyzerActionResponse,
    unknown,
    AnalyzerActionParams
  >
): UseMutationResult<AnalyzerActionResponse, unknown, AnalyzerActionParams> =>
  useMutation({
    mutationKey: ["analyzer_action"],
    mutationFn: analyzerActionHandler,
    ...options,
  });

const removeAnalyzer = async (
  interactionId: string
): Promise<RemoveAnalyzerResponse> => {
  const response = await axiosInstance.post(PATHS.REMOVE_ANALYZER, null, {
    params: { interactionId },
  });

  return {
    success: true,
    message: response.data as string,
  };
};

const useRemoveAnalyzer = (
  options?: UseMutationOptions<
    RemoveAnalyzerResponse,
    unknown,
    string
  >
): UseMutationResult<RemoveAnalyzerResponse, unknown, string> =>
  useMutation({
    mutationKey: ["remove_analyzer"],
    mutationFn: removeAnalyzer,
    ...options,
  });

const ManualBotService = Object.freeze({
  useAddAnalyzer,
  useAddAnalyzerAdhoc,
  useAnalyzerAction,
  useRemoveAnalyzer,
});

export default ManualBotService;
